import { Box, Typography } from '@mui/material';
import { Skeleton } from '@mui/material';
import React from 'react';

interface IMetricFooter {
  currentCount: number;
  totalCount: number;
}

export const MetricFooterSkeleton = () => {
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      style={{
        // paddingRight: '5px',
        padding: '8px',
        minHeight: '25px',
        borderTop: '1px solid #dcdcdc',
      }}
    >
      <Skeleton variant="text" width={120} />
    </Box>
  );
};

const MetricFooter = (props: IMetricFooter) => {
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      style={{
        // paddingRight: '5px',
        padding: '8px',
        minHeight: '25px',
        borderTop: '1px solid #dcdcdc',
      }}
    >
      {props.totalCount > 0 ? (
        <Typography variant="caption">
          Showing {props.currentCount.toLocaleString()} of{' '}
          {props.totalCount.toLocaleString()}
        </Typography>
      ) : (
        <Typography variant="caption">Showing no results</Typography>
      )}
    </Box>
  );
};

export default MetricFooter;
